<template>
  <div class="flex flex-col">
    <div class="relative mb-2">
      <div class="max-h-80 overflow-y-scroll">
        <div v-for="(applicant, index) in applicants" :key="index" class="flex flex-col mb-10 pt-2"> <!-- attendee -->
          <div class="flex mb-4 relative">
            <div @click="removeApplicant(applicant)" class="absolute pin-t pin-r -mt-2 cursor-pointer">
              <icon name="delete" :center="false" class="w-4 h-4" />
            </div>
            <div class="w-full flex flex-col mr-4">
              <label class="mb-1 text-sm flex items-center">
                <icon name="user" :center="false" class="w-3 h-4 text-tertiary mr-2" />
                Attendee #{{ index + 1 }}
              </label>
              <input class="w-full border border-grey-dark rounded p-3 text-sm" placeholder="Their name" v-model="applicant.applicant_name" />
            </div>
            <div class="w-full flex flex-col">
              <label class="mb-1 text-sm">Phone Number</label>
              <input class="w-full border border-grey-dark rounded p-3 text-sm" placeholder="Their phone number" v-model="applicant.applicant_phone" />
            </div>
          </div>
          <div class="flex flex-col">
            <label class="mb-1 text-sm">Email Address</label>
            <input class="w-full border border-grey-dark rounded p-3 text-sm" placeholder="Their email address" v-model="applicant.applicant_email" />
          </div>
        </div> <!-- attendee end -->
      </div>
      <div v-if="applicants.length > 1" class="absolute pin-b pin-l pin-r w-full h-5 scroll-fade border-b"></div>
    </div>
    <button @click="addApplicant" class="flex items-center justify-center text-tertiary px-8 py-2 rounded-lg cursor-pointer border-2 border-tertiary">
      <icon name="add" :center="false" class="w-6 h-6 mr-1" /> Add {{ applicants.length > 0 ? 'another' : '' }} attendee
    </button>
  </div>
</template>

<script>
export default {
  name: 'Applicants',

  props: ['value'],

  computed: {
    applicants: {
      get () {
        return this.value
      },

      set (values) {
        this.$emit('input', values)
      }
    }
  },

  methods: {
    removeApplicant (applicant) {
      let values = [...this.value]
      values.splice(this.value.indexOf(applicant), 1)
      this.applicants = values
    },

    addApplicant () {
      this.applicants = [...this.value, { applicant_name: '', applicant_phone: '', applicant_email: '' }]
    }
  }
}
</script>

<style scoped>
.scroll-fade {
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 25%, rgba(255,255,255,0) 100%);
}
</style>
